import React from "react";
import { HomeListSearchLoaderTemplate } from "themes/application/home/components";

function HomeListSearchLoader(props) {
    return <HomeListSearchLoaderTemplate {...props} />;
}

export default HomeListSearchLoader;
